export default function SectionCard({ title, children }) {
  return (
    <div className="fc-profile-section">
      {title && <div className="fc-section-label mb-3">{title}</div>}
      {children}
    </div>
  );
}
